import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  root: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    // flex: 1,
  },
  option: {
    // borderBottomWidth: 1,
    // borderBottomColor: PALETTE.primaryStrokeLine,
    paddingHorizontal: 20,
    paddingVertical: 24,
  },
  wrapper: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  selected: {
    width: 35,
  },
  optionTitle: {
    // flex: 1,
  },
  separator :{
    borderBottomWidth: 1,
    borderBottomColor: PALETTE.primaryStrokeLine,
  },
  searchCircle: {
     paddingLeft: 5
  },
  bpNameWrapper: {
    paddingLeft: '2.6rem'
  }
});

export const selectedSVGStyles = {
  color: PALETTE.primaryText,
  radius: 4,
};
